import { useEffect, useState } from 'react'

import { OMNIPOOL_CONFIG } from '~/lib/config'
import { useRecentlyClaimed } from '~/lib/useRecentlyClaimed'
import { useWallet } from '~/lib/useWallet'
import type { Rewards } from '~/pages/CrossChainFarmPage'

export function useRewardsV2(): Rewards {
	const { account } = useWallet()

	const { isRecentlyClaimed } = useRecentlyClaimed()

	const [rewards, setRewards] = useState<Rewards>()

	useEffect(() => {
		if (!account) {
			return
		}

		fetch(`${OMNIPOOL_CONFIG.farmingURL}/v1/users/rewards/${account}`, {
			method: 'get',
		})
			.then((response) => {
				if (response.status !== 200) {
					throw new Error('Get pools rewards failed')
				}

				return response.json()
			})
			.then((rewards: Rewards) => {
				setRewards({
					...rewards,
					totalAvailableToClaim: isRecentlyClaimed
						? '0'
						: rewards.totalAvailableToClaim,
				})
			})
			.catch((error) => {
				console.warn(error)
			})
	}, [account, isRecentlyClaimed, setRewards])

	return rewards
}
